module.exports = __webpack_public_path__ + "static/2012-layer-1-20b4a728ce7fe5fe7fee2cde1808c940.png";